import { zfUtils } from "./zf_utils";
export class zfctkt {
    static init() {
        try {
            var target;
            if ($(window).outerWidth() > 720) {
                target = ".zfctkt-image";
            }
            else {
                target = ".zfctkt-mobile-image";
            }
            $(".zfctkt-teaser " + target).each(function () {
                this.src = this.getAttribute("data-src");
            });
            if ($(window).outerWidth() < 721) {
                $(".zfctkt-text").css("max-height", "");
                $(".zfctkt-text-extension").hide();
            }
        }
        catch (err) {
            console.log("Initalization failed: zfctkt.init() " + err.message);
        }
    }
    static calcContent() {
        $(".zfctkt-teaser").each(function () {
            if (!this.initialized) {
                this.initialized = true;
                var that = this;
                that.v = {
                    content: $(that).find(".zfctkt-content"),
                    wrapper: $(that).find(".zfctkt-content-wrapper"),
                    headline: $(that).find(".zfctkt-headline"),
                    text: $(that).find(".zfctkt-text"),
                    extension: $(that).find(".zfctkt-text-extension"),
                };
                $(this)
                    .find(".zfctkt-image")
                    .on("load", function () {
                    that.v.text.css("max-height", "");
                    that.v.textLineheight = parseInt(that.v.text.css("line-height"));
                    if (that.v.content.outerHeight() - that.v.headline.outerHeight() <
                        that.v.text.outerHeight()) {
                        var maxHeight = Math.floor((that.v.content.outerHeight() -
                            that.v.headline.outerHeight()) /
                            that.v.textLineheight) * that.v.textLineheight;
                        that.v.text.css("max-height", maxHeight);
                        that.v.extension.show();
                    }
                    else {
                        that.v.extension.hide();
                    }
                });
            }
        });
    }
}
zfctkt.resizeKey = null;
try {
    zfUtils.onReady(function () {
        zfctkt.calcContent();
        zfctkt.init();
        if (zfctkt.resizeKey !== null) {
            zfUtils.offResize(zfctkt.resizeKey);
        }
        zfctkt.resizeKey = zfUtils.onResize(function () {
            zfctkt.init();
        });
    });
}
catch (err) {
    console.log("Initalization failed: zfctkt.init() " + err.message);
}
